import { signOut } from 'next-auth/react';
import { getI18n } from 'react-i18next';
import grispiApi from '../../apis/grispiApi';
import { disconnectChat } from '../../clients/chat/connection';
import { grispiNotification } from '../../store/useNotificationStore';
import { removeAllStorageItems, setLocalStorageItem, StorageHelperKeys } from '../../utils/storageHelpers';
import getStore from '../../utils/store/getStore';

const terminateSession: (messageText?: string) => Promise<void> = async (messageText) => {
    document.querySelectorAll('iframe').forEach((el) => el.remove());

    await disconnectChat();
    removeAllStorageItems();

    // redirect uses NEXTAUTH_URL which doesn't support dynamic subdomains
    // i.e. cayci.grispi.com logout redirects to grispi.com which is wrong
    // console.debug(
    //     `logout terminateSession:`,
    //     'iframe, browser-storage and mobxStore cleared',
    //     'will terminate session via next-auth signOut method'
    // );

    await signOut({ redirect: false });
    // console.debug(`logout terminateSession:`, 'session terminated, should redirect to login page now');
    setLocalStorageItem(StorageHelperKeys.USER_LOGOUT, true);

    if (messageText) {
        grispiNotification('error', messageText, 'terminateSession');
    }

    // await redirectTo('/login-page');

    getStore().resetStores();
};
export const logout = async (): Promise<any> => {
    // set loggedOut = true on local storage
    setLocalStorageItem(StorageHelperKeys.LOGGED_OUT, true);

    try {
        await grispiApi.post('/logout');
        // console.debug(`logout: success`, 'will terminate session now');

        await terminateSession();
    } catch (error) {
        console.error(`logout error:`, error);
        // res.status === 500  =>  set loggedOut = false on local storage
        if (error?.response?.status === 401) {
            setLocalStorageItem(StorageHelperKeys.LOGGED_OUT, true);
            await terminateSession(getI18n().t('message.onSessionFailed', { ns: 'common' }));
            return;
        } else if (error?.response?.status === 500) {
            setLocalStorageItem(StorageHelperKeys.LOGGED_OUT, true);
            await terminateSession(getI18n().t('message.onSessionFailed', { ns: 'common' }));
            return;
        }

        setLocalStorageItem(StorageHelperKeys.LOGGED_OUT, false);
        throw new Error(error);
    }
};

export default logout;
